import { render, staticRenderFns } from "./NamespaceSelector.vue?vue&type=template&id=2c330798&scoped=true&"
import script from "./NamespaceSelector.vue?vue&type=script&lang=js&"
export * from "./NamespaceSelector.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceSelector.vue?vue&type=style&index=0&id=2c330798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c330798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
